
import {
  attrState,
  fabricState,
  inStockState,
  layoutState,
  sizesState,
  uiState,
  generalState,
  renderState,
  presetsState,
  filtersState,
  skeletonState,
} from './partialState'

export default {
  routes: [],
  maps: [],
  root: '',
  ui: uiState,
  general: generalState,
  render: renderState,
  config: {
    attr: attrState,
    fabric: fabricState,
    inStock: inStockState,
    layout: layoutState,
    sizes: sizesState,
    presets: presetsState,
    skeleton: skeletonState,
  },
  user: {
    me: {},
    isLogined: false,
  },
  filters: filtersState
};
